import React from "react";
import {
  KeyboardAvoidingView,
  Platform,
  StyleSheet,
  Dimensions,
} from "react-native";

const ScreenContainer = ({ children, style }: any) => {
  return (
    <KeyboardAvoidingView
      style={[{ flex: 1 }, style]}
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      enabled={true}
    >
      {children}
    </KeyboardAvoidingView>
  );
};

const WindowWith = () => {
  return Dimensions.get("window").width;
};

const globalStyles = StyleSheet.create({
  centerFlex: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  centerMargin: {
    marginLeft: "auto",
    marginRight: "auto",
  },
  containerPadding: {
    paddingHorizontal: 20,
  },

  transparentBorderInput: {
    backgroundColor: "transparent",
    borderBottomWidth: 1,
    borderColor: "#E1E3E8",
    height: 50,
    marginTop: 20,
  },

  paddingBottom10: {
    paddingBottom: 10,
  },
});
const colors = {
  bg: {
    primary: "#FF7D70",
    secondary: "",
    light: "#FAFAFA",
    medium: "#F1F2F6",
    green: "#00B000",
    greenLight: "#7FFF70",
    white: "#fff",
    red: "#FF7070",
    blue: '#7086FF',
    yellow: '#FFD770'
  },
  text: {
    primary: "#000",
    secondary: "#d8d8d8",
    medium: "#454545",
    white: "#fff",
  },
};

export { ScreenContainer, WindowWith, globalStyles, colors };
